module.exports = __webpack_public_path__ + "img/personal_title.427d54e9.svg";